var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnderProbationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 64,
    height: 64,
    rx: 12.8,
    fill: "#EAFAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.16 40.5C42.4266 39.5533 43.4667 37.4866 43.4667 35.9133V26.0067C43.4667 24.3667 42.2133 22.5533 40.68 21.98L34.0266 19.4866C32.92 19.0733 31.1066 19.0733 30 19.4866L23.3467 21.98C21.8133 22.5533 20.56 24.3667 20.56 26.0067V35.9133C20.56 37.4866 21.6 39.5533 22.8666 40.5L28.6 44.78C30.48 46.1933 33.5733 46.1933 35.4533 44.78L36.44 44.0333",
    stroke: "#0099FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 31.06C31.9466 31.06 31.88 31.06 31.8266 31.06C30.5733 31.02 29.5733 29.98 29.5733 28.7133C29.5733 27.42 30.6266 26.3667 31.92 26.3667C33.2133 26.3667 34.2667 27.42 34.2667 28.7133C34.2533 29.9933 33.2533 31.02 32 31.06Z",
    stroke: "#0099FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3467 34.7934C28.0667 35.6467 28.0667 37.0467 29.3467 37.9C30.8 38.8733 33.1867 38.8733 34.64 37.9C35.92 37.0467 35.92 35.6467 34.64 34.7934C33.2 33.82 30.8133 33.82 29.3467 34.7934Z",
    stroke: "#0099FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderProbationIcon);
export default __webpack_public_path__ + "static/media/underProbationIcon.b027fac07e3119b779c8b6d92c5621f1.svg";
export { ForwardRef as ReactComponent };